// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__10o2_","container":"Main_container__1OsHM","contents":"Main_contents__3hGEX","work1":"Main_work1__10onC","work2":"Main_work2__HFSrb","work3":"Main_work3__iP12w"};